<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M2.649,16.4a.5.5,0,0,0-.841.245L.394,23.01a.5.5,0,0,0,.134.462.509.509,0,0,0,.462.135l6.364-1.414a.5.5,0,0,0,.245-.842Z"/><path d="M17.852,7.208,6.892,18.168a.252.252,0,0,0,0,.354L8.66,20.29a.507.507,0,0,0,.707,0L19.974,9.683a.5.5,0,0,0,0-.707L18.206,7.208A.252.252,0,0,0,17.852,7.208Z"/><path d="M16.792,5.794,15.024,4.027a.5.5,0,0,0-.707,0L3.71,14.633a.5.5,0,0,0,0,.707l1.768,1.768a.252.252,0,0,0,.354,0l10.96-10.96A.252.252,0,0,0,16.792,5.794Z"/><path d="M22.449,1.552a4.005,4.005,0,0,0-5.658,0l-.707.707a.5.5,0,0,0,0,.707l4.95,4.949a.513.513,0,0,0,.707,0l.708-.707A4,4,0,0,0,22.449,1.552Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'pencil-2',
    },
    name: {
      type: String,
      required: false,
      default: 'Pencil2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>